"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertor = exports.taskFromOperationNode = void 0;
const common_1 = require("@finley-technologies/common");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const converterUtils_1 = require("../converterUtils");
const types_1 = require("./types");
const uinode_1 = require("./uinode");
const taskToOperationNode = (task) => {
    const { srcArtifactSlug: _unused2, ...nodeConfiguration } = task;
    return (0, converterUtils_1.newOperationNode)(types_1.nodeType, nodeConfiguration);
};
const taskFromOperationNode = ({ srcNodes, operationNode, }) => {
    (0, common_1.finleyAssert)(uinode_1.operation_sanitize.isNode(operationNode), 'operation node is not a node');
    const { configuration } = operationNode;
    (0, common_1.finleyAssert)(srcNodes.length === 1, `edit node has [${srcNodes.length}] src node`);
    return {
        srcArtifactSlug: (0, converterUtils_1.getSrcArtifactSlug)(srcNodes[0]),
        ...configuration,
    };
};
exports.taskFromOperationNode = taskFromOperationNode;
exports.convertor = {
    operation: 'sanitize',
    nodeType: types_1.nodeType,
    taskToOperationNode,
    taskFromOperationNode: exports.taskFromOperationNode,
    toTransformation: (task) => {
        const { baseFields, delimiter, doNotSanitizeFieldNames } = task;
        const sanitizeFieldNames = !doNotSanitizeFieldNames;
        return {
            isValid: true,
            data: {
                operation: 'sanitize',
                srcDataTape: {
                    baseFields,
                    delimiter,
                },
                sanitizeFieldNames,
            },
        };
    },
    getDataDictionaryEntry: (task, { artifactSlug }) => ({
        kind: 'tape',
        artifactSlug,
        columns: task.baseFields.map(tape_sanitizer_1.toColumnInfo),
    }),
};
//# sourceMappingURL=converter.js.map